import React from "react";
import { useTranslation } from "react-i18next";
import StatCard from "../ui/StatCard";
import { formatInt, formatDurationSeconds } from "../../utils/formatters";

/**
 * KpiStrip — the 5-card row at the top of the analytics dashboard.
 *
 * Expects the `kpis` shape from `/api/analytics/overview`:
 *   { total_calls, calls_today, unique_callers, avg_duration_s,
 *     appointments_booked }
 * where each entry is `{ value, delta_pct }`.
 */
const KpiStrip = ({ kpis }) => {
  const { t } = useTranslation();
  const items = [
    {
      key: "total_calls",
      label: t("analytics.kpis.totalCalls"),
      icon: "phone_callback",
      ...kpis.total_calls,
      format: formatInt,
    },
    {
      key: "calls_today",
      label: t("analytics.kpis.callsToday"),
      icon: "today",
      ...kpis.calls_today,
      format: formatInt,
    },
    {
      key: "unique_callers",
      label: t("analytics.kpis.uniqueCallers"),
      icon: "groups",
      ...kpis.unique_callers,
      format: formatInt,
    },
    {
      key: "avg_duration_s",
      label: t("analytics.kpis.avgDuration"),
      icon: "timer",
      ...kpis.avg_duration_s,
      format: formatDurationSeconds,
    },
    {
      key: "appointments_booked",
      label: t("analytics.kpis.appointments"),
      icon: "event_available",
      ...kpis.appointments_booked,
      format: formatInt,
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {items.map((k) => (
        <StatCard
          key={k.key}
          icon={k.icon}
          label={k.label}
          value={k.format(k.value)}
          delta={k.delta_pct}
        />
      ))}
    </div>
  );
};

export default KpiStrip;
